require('./loading');

let free_checkout = (function( $ ) {

	let _init = function() {
		let $button = $( '#free_checkout' );

		if ( $button.length > 0 ) {
			$button.on( 'click', _process_checkout )
		}
	};

	let _process_checkout = function( e ) {
		e.preventDefault();

		if ( $( this ).hasClass( 'loading' ) ) {
			return;
		}

		$( this ).loading();
		$( this ).addClass( 'loading' );

		$.post( ScriptData.ajaxurl, {
			action : 'crate_free_checkout_process',
			nonce  : ScriptData.crate_free_checkout_process_nonce,
			payee  : $( this ).val()
		}, _process_checkout_response ).fail( function($xhr,textStatus,errorThrown){
			console.log( $xhr );
			console.log( textStatus );
			console.log( errorThrown );
		});
	};

	let _process_checkout_response = function( response ) {
		if ( response.success ) {
			window.location.href = response.redirect;
		} else {
			console.log( response.error );
		}
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = free_checkout;